import { MinzeElement, EventListeners, Reactive, Attrs } from 'minze'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'
import { unescapeHtml } from '../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'lvc-report-problem-sent-popup', {
  title: 'Signaler un problème',
  subtitle: 'Merci pour votre retour!',
  secondSubtitle: 'Notre équipe va analyser votre commentaire.',
  closeButton: 'Fermer',
})

Locale.getInstance().registerKeySet('en', 'lvc-report-problem-sent-popup', {
  title: 'Report a problem',
  subtitle: 'Thank you for your feedback!',
  secondSubtitle: 'Our team will analyze your comment.',
  closeButton: 'Close',
})

export class LvcReportProblemSentPopup extends MinzeElement {
  onClickClose(): void {
    this.remove()
  }

  html = () => `
    <lvc-simple-modal id="modal" no-close-button="true" modal-title="${Locale.getKey('lvc-report-problem-sent-popup.title')}" title-size="24px" simple-close-button="true" text-transform="uppercase" background="white" max-width="512px">
        <div class="modal-content">
            <div class="subtitle-container">
                <lvc-text font-preset="medium">
                ${Locale.getKey('lvc-report-problem-sent-popup.subtitle')}
                </lvc-text>
                <lvc-text font-preset="medium">
                ${Locale.getKey('lvc-report-problem-sent-popup.secondSubtitle')}
                </lvc-text>
            </div>
            <div class="bottom-buttons-container">
                <lvc-button enable-hover-box-shadow="true" id="close-button" name="close-button"border-radius="999px" height="fit-content" width="fit-content" padding="14px 24px" >
                ${Locale.getKey('lvc-report-problem-sent-popup.closeButton')}
                </lvc-button>
            </div>
        </div>
    </lvc-simple-modal>
    `

  css = () => `
    :host {
      display: inline;
    }

    .modal-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 24px;
    }

    .bottom-buttons-container{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }


  `
  eventListeners: EventListeners = [
    ['[name="close-button"]', 'click', this.onClickClose.bind(this)],
  ]
}
